module.exports = " <div class=menu-bar> <ul> <li class=menu-item><label>File</label></li> <li class=menu-item><label>View</label></li> <li class=menu-item><label>Special</label> </li> </ul> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DosFileMenu.vue
// module id = 174
// module chunks = 2